import { AxiosResponse } from "axios";
import { ICommit } from "@/apps/merchant3/shared-models/ICommit";
import { getCart } from "@/apps/merchant3/services/carts.service";
import {
  IPricing,
  IStateCart,
  IPaymentTerms,
} from "@/apps/merchant3/models/IStateCart";
import { ICartWrap } from "@/apps/merchant3/models/IStateCart";
import { EContract } from "@/apps/merchant3/models/IStateContract";

type IOrder = ICartWrap;
const actions = {
  loadCart: async ({ commit }: ICommit, cartTag: string): Promise<void> => {
    try {
      const response: AxiosResponse<IOrder> = await getCart(cartTag);
      commit("SET_CART", response.data);
    } catch (error) {
      if (error) console.log("ERROR_SOMETHING_GOES_WRONG");
    }
  },
  resetCart: ({ commit }: ICommit): void => {
    commit("RESET_CART");
  },
  setSelectedOffer: ({ commit }: ICommit, payload: number): void => {
    commit("SET_SELECTED_OFFER", payload);
  },
  setPricing: ({ commit }: ICommit, payload: IPricing[]): void => {
    commit("UPDATE_PRICING", payload);
  },
  setCart: ({ commit }: ICommit, payload: IStateCart): void => {
    commit("SET_CART", payload);
  },
  setCartTag: ({ commit }: ICommit, payload: string): void => {
    commit("SET_CART_TAG", payload);
  },
  setRetailPrice: ({ commit }: ICommit, payload: number): void => {
    commit("SET_RETAIL_PRICE", payload);
  },
  setSelectedImageUrl: ({ commit }: ICommit, payload: string): void => {
    commit("SET_SELECTED_IMAGE_URL", payload);
  },
  setDownPayment: ({ commit }: ICommit, payload: number): void => {
    commit("SET_DOWN_PAYMENT", payload);
  },
  setHasReceivedWelcomeCall: ({ commit }: ICommit, payload: number): void => {
    commit("SET_HAS_RECEIVED_WELCOME_CALL", payload);
  },
  setWelcomeCallRequired: ({ commit }: ICommit, payload: number): void => {
    commit("SET_WELCOME_CALL_REQUIRED", payload);
  },
  setContractSignedTimestamp: ({ commit }: ICommit, payload: string): void => {
    commit("SET_CONTRACT_SIGNED_TIMESTAMP", payload);
  },
  setAttempts: ({ commit }: ICommit, payload: number): void => {
    commit("SET_ATTEMPTS", payload);
  },

  setContractVerballyAccepted: (
    { commit }: ICommit,
    payload: EContract
  ): void => {
    commit("SET_CONTRACT_VERBALLY_ACCEPTED", payload);
  },

  setNewPhoneNumber: ({ commit }: ICommit, payload?: string | null): void => {
    commit("SET_NEW_PHONE_NUMBER", payload);
  },

  setDevicePhoneNumber: ({ commit }: ICommit, payload?: string): void => {
    commit("SET_DEVICE_PHONE_NUMBER", payload);
  },

  updatePricing: ({ commit }: ICommit, payload: IPaymentTerms): void => {
    commit("UPDATE_PRICING", payload);
  },

  setActivationMethod: ({ commit }: ICommit, payload: string | null): void => {
    commit("SET_ACTIVATION_METHOD", payload);
  },

  setCurrentPage: ({ commit }: ICommit, payload: string): void => {
    commit("SET_CURRENT_PAGE", payload);
  },

  setImei: ({ commit }: ICommit, payload: number | null): void => {
    commit("SET_IMEI", payload);
  },
  setStep: ({ commit }: ICommit, payload: string | null): void => {
    commit("SET_STEP", payload);
  },
  setIncodeOnBoardCompleted: (
    { commit }: ICommit,
    payload: boolean | null
  ): void => {
    commit("SET_INCODE_ONBOARD_COMPLETE", payload);
  },
  setIncodeOnBoardStatus: (
    { commit }: ICommit,
    payload: string | null
  ): void => {
    commit("SET_INCODE_ONBOARD_STATUS", payload);
  },
  setOneTimePassword: (
    { commit }: ICommit,
    payload: { otp: string; currentBalance: number }
  ): void => {
    commit("SET_ONE_TIME_PASSWORD", payload);
  },
  setUniqueRequests: ({ commit }: ICommit, payload: string[] | null): void => {
    commit("SET_UNIQUE_REQUESTS", payload);
  },
  setConfigurations: ({ commit }: ICommit, payload: string[] | null): void => {
    commit("SET_CONFIGURATIONS", payload);
  },
};

export default actions;
